import { PatientService } from '@/services/patient.service';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {
          firstname: '',
          lastname: ''
        };
      }
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  methods: {
    async resetPassword() {
      try {
        const {
          data
        } = await PatientService.resetPassword(this.rowData.id);
        if (data) {
          this.$emit('show-toast', 'Password updated successfully!', 'success');
        }
      } catch (error) {
        this.$emit('show-toast', error);
      }
    }
  }
};